import { useIsomorphicAxios } from '@unisporkal/federation';
import { useMemo } from 'react';
import { GalleryService } from '../services/galleryService';

export function useGalleryService() {
  const axios = useIsomorphicAxios();
  return useMemo(() => new GalleryService(axios), [axios]);
}
